import { RouteType } from '@/Routes';
import { lazy } from 'react';

const GfcHistory = lazy(() => import('@/pages/gfc/histories'));
const GfcReceipt = lazy(() => import('@/pages/gfc/receipt'));

const ServerGfc: RouteType[] = [
  { path: '/gfc/histories', component: GfcHistory },
  { path: '/gfc/receipt', component: GfcReceipt },
];

export default ServerGfc;
